import React, {MutableRefObject, useEffect, useRef, useState} from 'react';
import './businessAccordion.scss';
import {AddBusinessType} from "../../models";
import {Button} from 'components';


export interface BusinessPanel {
    id: number,
    activeTab?: number,
    index?: number,
    activateTab?: (index: number) => any
    business: AddBusinessType
}

interface Props {
    panels: BusinessPanel[]
}


export const BusinessAccordion: React.FC<Props> = ({panels}) => {
    const [activeTab, setActiveTab] = useState<number>(0)

    const bodyRef = useRef() as MutableRefObject<HTMLDivElement>;

    const [height, setHeight] = useState<number>(0);

    useEffect(() => {
        setHeight(bodyRef.current.scrollHeight)
    }, [activeTab])

    const activateTab = (index: any) => {
        activeTab === index ? setActiveTab(-1) : setActiveTab(index)
    }

    return (
        <div className={'business-accordion'}>
            {
                panels.map(({id, business}, index) =>
                    <div key={index} className='business-accordion_panel' aria-expanded={activeTab === index}>
                        <div className='business-accordion_panel__label'
                             role='tab'
                             onClick={() => activateTab(index)}>
                            <div className="business-accordion_panel__label_top">
                                <span id={'title'}>{business?.information?.name}</span>
                                <span
                                    id={business?.is_approved ? 'approved' : 'pending'}>
                                    {business?.is_approved ? 'approved' : 'pending'}
                                </span>
                            </div>
                            <div className="business-accordion_panel__label_bottom">
                                <div className="business-accordion_panel__label_bottom_left">
                                    <span>Created: <span>{business.information?.title}</span></span>
                                    <span>Employee Count: <span>{"13-50 employees"}</span></span>
                                    <span>Level of Membership: <span>{'Small Businesses'}</span></span>
                                </div>
                                <div className="business-accordion_panel__label_bottom_right">
                                    <Button text={'View More'} type={'primary'}/>
                                </div>
                            </div>
                        </div>

                        <div className='business-accordion_panel__inner'
                             style={{height: `${activeTab === index ? height : 0}px`}}
                             ref={bodyRef}
                             aria-hidden={activeTab !== index}
                        >
                            <div className='business-accordion_panel__inner__content'>
                                <div className='business-accordion_panel__inner__content_info'>
                                    <div className='business-accordion_panel__inner__content_info_item'>
                                        <span>Business Category:</span>
                                        <p>{business.category?.category ?? 'N/A'}</p>
                                    </div>
                                    <div className='business-accordion_panel__inner__content_info_item'>
                                        <span>Business Type:</span>
                                        <p>{business.details?.business_type ?? 'N/A'}</p>
                                    </div>
                                    <div className='business-accordion_panel__inner__content_info_item'>
                                        <span>Registration Number:</span>
                                        <p>{business.details?.registration_number ?? 'N/A'}</p>
                                    </div>
                                    <div className='business-accordion_panel__inner__content_info_item'>
                                        <span>TRN Number:</span>
                                        <p>{business.details?.tax_registration_number ?? 'N/A'}</p>
                                    </div>
                                    <div className='business-accordion_panel__inner__content_info_item'>
                                        <span>Target Market:</span>
                                        <p>{business.category?.target_market}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

